/// <reference path="../libs/scrolltoid.js" />
/// <reference path="../framework/evo.js" />
/// <reference path="../libs/jquery.ba-throttle-debounce.js" />
/// <reference path="../components/timeline.js" />
/// <reference path="../components/modal-extras.js" />
/// <reference path="../components/accordion.js" />
/// <reference path="../libs/resize-sensor.js" />
/// <reference path="../libs/jquery.sticky-kit.js" />

(function ($) {
    var prevTrip = 'destination',
        contentCache = {},
        selectors = {
            activeClass: 'active',
            destination: 'destination',
            overrideSelector: 'section.section-override',
            rootSelector: 'section.section-root',
            sectionNameAttribute: 'section-name',
            tripTile: '.js-trip-tile',
            tripDate: '.js-trip-date',
            tripBuyBox: '.js-trip-buy-box',
            tripFinePrint: '.js-trip-fine-print',
            tripName: '.js-trip-name'
        };

    function setContent(tripId) {
        if (!contentCache[tripId]) {
            contentCache[tripId] = {};
            $('#' + tripId + ' section[data-' + selectors.sectionNameAttribute + ']').each(function () {
                var $this = $(this),
                    name = $this.data(selectors.sectionNameAttribute);

                if (name) {
                    var html = $this.find('[data-cms-section]').children();
                    contentCache[tripId][name] = html.length ? html : '';
                }
            });
        }
    };

    function getHtml($el) {
        if (!$el || !$el.length)
            return '';
        var html = '';

        $el.each(function () {
            html += this.innerHTML;
            $(this).children().each(function () {
                html += getHtml($(this));
            });
        });
        return html;
    }

    function $htmlEquals($source, $test) {
        if (!$source || !$test || !$source.length || !$test.length)
            return $source == $test;

        var html1 = getHtml($source),
            html2 = getHtml($test);

        return html1 === html2;
    };

    function updateContent() {
        var tripId = (window.location.hash && window.location.hash.substr(1)) || selectors.destination;

        tripId = tripId.replace(/[^-a-zA-Z0-9]*/g, '');

        setContent(tripId);
        $(selectors.rootSelector).each(function () {
            var $this = $(this),
                name = $this.data(selectors.sectionNameAttribute),
                prevContent = (contentCache[prevTrip][name] || contentCache[selectors.destination][name] || $('')),
                nextContent = (contentCache[tripId][name] || contentCache[selectors.destination][name] || $(''));

            if (!$htmlEquals(prevContent, nextContent)) {
                $this.hide().children().detach();
                $this.append(nextContent);
                switch ($this.data('animation') || 'fade') {
                    case 'fade':
                        $this.fadeIn();
                        break;
                    case 'slide':
                        $this.slideDown();
                        break;
                    default:
                        $this.fadeIn();
                }
            }
        });

        prevTrip = tripId;

        setUIState(tripId);
    };

    function setUIState(tripId) {
        var $tripTile = $('[data-trip-id=' + tripId + ']'),
            $tripDestination = $('#destination'),
            $tripDate = $(selectors.tripDate),
            $tripBuyBox = $(selectors.tripBuyBox),
            $tripFinePrint = $(selectors.tripFinePrint),
            $tripName = $(selectors.tripName),
            $itineraryAccordionHead = $('#itinerary-section').find('.accordion-head');

        //if there is a selcted one, deselect and add class active, then update values in book it button
        if ($tripTile.length > 0) {
            //update bookit button
            $tripDate.text($tripTile.data('trip-date'));
            $tripFinePrint.text($tripTile.data('message'));
            $tripName.text($tripTile.data('trip-name'));
            $tripBuyBox.addClass(selectors.activeClass);
            $(selectors.tripTile).removeClass(selectors.activeClass);
            $tripTile.addClass(selectors.activeClass);

            ////show itinerary section.
            if (!$itineraryAccordionHead.hasClass('expanded') && evo.isMobile) {
                $itineraryAccordionHead.trigger('click');
            }
        }
        else {
            $('[data-trip-id]').removeClass(selectors.activeClass);
            $tripBuyBox.removeClass(selectors.activeClass);
        }

        $(window).trigger('resize');
    };

    function resetHash() {
        var top = evo.$.body.scrollTop();
        window.location.hash = '';
        evo.$.body.scrollTop(top);
    };

    function loadStickyNav() {
        var $stickyElement = $('.js-sticky-nav'),
            isSticky = false;
        //test against the window width and whether or not sticky-kit has been set up.
        function detectSticky() {
            if (evo.$.window.width() >= evo.mq.screenSmMin) {
                if (isSticky === false) {
                    $stickyElement.stick_in_parent();
                    isSticky = true;
                }
            }
            else {
                //remove it for mobile
                if (isSticky === true) {
                    $stickyElement.trigger('sticky_kit:detach');
                    isSticky = false;
                }
            }
        };

        detectSticky();

        //throttle the resize event
        var resizeTimer;
        evo.$.window.on('resize', function (e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(detectSticky, 250);
        });

        evo.$.body.scrollspy({
            target: '.navbar',
            offset: $('.js-sticky-nav').height() + 1
        });
    };

    setContent(selectors.destination);

    var $trips = $(selectors.tripTile);
    if ($trips.length == 1) {
        $('.js-trip-container').hide();
        location.hash = $trips.data('trip-id') || '';
    }
    else if ($trips.length == 0) {
        $('.trip-selection-header').hide();
        $('hr.js-trip-container').hide();
    }

    $(function () {
        updateContent();

        if ($trips.length > 1)
            window.onhashchange = updateContent;

        $trips.on('click', function (e) {
            var $this = $(this);
            if ($this.hasClass(selectors.activeClass)) {
                e.preventDefault();
                $this.removeClass(selectors.activeClass);
                resetHash();
            }
        });

        // prevent scrolling on empty hash
        $('.destination-trip').on('click touchend', 'a[href=#]', function (e) {
            e.preventDefault();
            resetHash();
        });

        //prevent default of utility nav links, so as to not interfere with onhashchange event above
        $(".utility-nav-anchor-links a").on('click', function (e) {
            e.preventDefault();
        });

        loadStickyNav();

        //init the sticky nav
        $('.js-scroll-to-id').scrollToID({
            offset: $('.js-sticky-nav').height()
        });

        $('.accordion-head').on('click touchend', function () {
            evo.$.body.trigger('reinit.evo.maps');
        });
    });
})(jQuery);